import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardStats: {
    users: {
      total: 0,
      active: 0,
      inactive: 0,
    },
    land: {
      total: 0,
    },
    news: {
      total: 0,
      published: 0,
      draft: 0,
    },
    contacts: {
      total: 0,
      replied: 0,
    },
  },
  farmOverview: {
    location: {
      village: "",
      district: "",
      state: "",
    },
    weather: {
      temperature: "",
      humidity: "",
      wind_speed: "",
      condition: "",
    },
    summary: {
      total_fields: 0,
      total_area_meters: 0,
      healthy_fields: 0,
      need_irrigation: 0,
    },
    farm_zones: [],
  },
  salesOverview: [],
  recentOrders: [],
  topSellingProducts: [],
  loading: false,
  error: null,
  success: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // Dashboard statistics
    getDashboardStatsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getDashboardStatsSuccess(state, action) {
      state.loading = false;
      // The action.payload already contains the data from response.data.data
      state.dashboardStats = action.payload;
      state.success = true;
    },
    getDashboardStatsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Farm overview
    getFarmOverviewStart(state) {
      state.loading = true;
      state.error = null;
    },
    getFarmOverviewSuccess(state, action) {
      state.loading = false;
      state.farmOverview = action.payload;
      state.success = true;
    },
    getFarmOverviewFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Sales overview
    getSalesOverviewStart(state) {
      state.loading = true;
      state.error = null;
    },
    getSalesOverviewSuccess(state, action) {
      state.loading = false;
      state.salesOverview = action.payload;
      state.success = true;
    },
    getSalesOverviewFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Recent orders
    getRecentOrdersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getRecentOrdersSuccess(state, action) {
      state.loading = false;
      state.recentOrders = action.payload;
      state.success = true;
    },
    getRecentOrdersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Top selling products
    getTopSellingProductsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTopSellingProductsSuccess(state, action) {
      state.loading = false;
      state.topSellingProducts = action.payload;
      state.success = true;
    },
    getTopSellingProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Reset state
    resetDashboardState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  getDashboardStatsStart,
  getDashboardStatsSuccess,
  getDashboardStatsFailure,
  getFarmOverviewStart,
  getFarmOverviewSuccess,
  getFarmOverviewFailure,
  getSalesOverviewStart,
  getSalesOverviewSuccess,
  getSalesOverviewFailure,
  getRecentOrdersStart,
  getRecentOrdersSuccess,
  getRecentOrdersFailure,
  getTopSellingProductsStart,
  getTopSellingProductsSuccess,
  getTopSellingProductsFailure,
  resetDashboardState,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
